export function roundTwoDecimalPlaces(value: number) {
  return Math.round(value * 100) / 100;
}
